/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S1_P1Inputs */

const en_guide_json_schema_s1_p1 = /** @type {(inputs: Guide_Json_Schema_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema is itself written in JSON. It describes what valid data looks like: which properties are required, what types they should be, value ranges, string patterns, and more. Validators use the schema to check whether a JSON document conforms to the expected structure.`)
};

const ko_guide_json_schema_s1_p1 = /** @type {(inputs: Guide_Json_Schema_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema는 그 자체가 JSON으로 작성됩니다. 유효한 데이터가 어떤 모습이어야 하는지를 설명합니다: 어떤 속성이 필수인지, 어떤 타입이어야 하는지, 값 범위, 문자열 패턴 등을 정의합니다. 유효성 검사기는 스키마를 사용하여 JSON 문서가 예상 구조에 부합하는지 확인합니다.`)
};

const ja_guide_json_schema_s1_p1 = /** @type {(inputs: Guide_Json_Schema_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema自体がJSONで記述されます。有効なデータがどのようなものかを記述します：どのプロパティが必須か、どの型であるべきか、値の範囲、文字列パターンなど。バリデータはスキーマを使用して、JSONドキュメントが期待される構造に準拠しているかを確認します。`)
};

/**
* | output |
* | --- |
* | "JSON Schema is itself written in JSON. It describes what valid data looks like: which properties are required, what types they should be, value ranges, strin..." |
*
* @param {Guide_Json_Schema_S1_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s1_p1 = /** @type {((inputs?: Guide_Json_Schema_S1_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S1_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s1_p1(inputs)
	if (locale === "ko") return ko_guide_json_schema_s1_p1(inputs)
	return ja_guide_json_schema_s1_p1(inputs)
});